import { render, staticRenderFns } from "./ShowCustomerAddressDetails.vue?vue&type=template&id=35e8ee8c&"
import script from "./ShowCustomerAddressDetails.vue?vue&type=script&lang=js&"
export * from "./ShowCustomerAddressDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports